export default __webpack_public_path__ + "static/media/step3.6e0811fb.png";